import { ComponentEx } from "../ComponentEx";
import ContextMenu from "../ContextMenu";
import Icon from "../Icon";
import { TD, TR } from "./MyTable";
import * as React from "react";
export const EMPTY_ID = "<Unspecified>";
class GroupingRow extends ComponentEx {
    mContextActions;
    constructor(props) {
        super(props);
        this.initState({
            context: undefined,
        });
        this.mContextActions = [
            {
                title: this.props.t("Expand all"),
                action: this.props.onExpandAll,
                show: true,
            },
            {
                title: this.props.t("Collapse all"),
                action: this.props.onCollapseAll,
                show: true,
            },
        ];
    }
    render() {
        const { t, count, expanded, groupId, groupName, width } = this.props;
        const { context } = this.state;
        return (React.createElement(TR, { key: `group-${groupId}`, onContextMenu: this.onContext },
            React.createElement(TD, { className: "table-group-header", "data-group": groupId, onClick: this.toggleGroup, colSpan: width },
                React.createElement(ContextMenu, { instanceId: groupId, actions: this.mContextActions, visible: context !== undefined, position: context, onHide: this.onHideContext }),
                React.createElement(Icon, { name: expanded ? "showhide-down" : "showhide-right" }),
                t(groupName) || t(EMPTY_ID),
                " (",
                count,
                ")")));
    }
    toggleGroup = () => {
        const { expanded, groupId, onToggle } = this.props;
        onToggle(groupId, !expanded);
    };
    onContext = (event) => {
        this.setState({ context: { x: event.clientX, y: event.clientY } });
    };
    onHideContext = () => {
        this.setState({ context: undefined });
    };
}
export default GroupingRow;
